(() => {
  const products = {
    'cozy-hoodie-grey': {title:'COZY HOODIE - GREY',price:'600 EGP',images:[
      'unlisted-cozy-hoodie-grey-1.webp?v=1791878551','unlisted-cozy-hoodie-grey-2.webp?v=1791878614','unlisted-cozy-hoodie-grey-3.jpg?v=1791878581','unlisted-cozy-hoodie-grey-4.jpg?v=1791878592']},
    'cozy-straight-leg-sweats-grey': {title:'COZY STRAIGHT LEG SWEATS - GREY',price:'550 EGP',images:[
      'unlisted-cozy-straight-grey-1.png?v=1791878605','unlisted-cozy-straight-grey-2.webp?v=1791878624','unlisted-cozy-straight-grey-3.webp?v=1791878634','unlisted-cozy-straight-grey-4.png?v=1791878647']},
    'cozy-fold-over-waist-sweatpants-grey': {title:'COZY FOLD-OVER WAIST SWEATPANTS - GREY',price:'900 EGP',images:[
      'unlisted-cozy-fold-grey-1.png?v=1791878687','unlisted-cozy-fold-grey-2.png?v=1791878661','unlisted-cozy-fold-grey-3.png?v=1791878673','unlisted-cozy-fold-grey-4.png?v=1791878699']}
  };
  const base = 'https://cdn.shopify.com/s/files/1/0769/8160/0410/files/';
  const listing = document.querySelector('#DropProducts');
  const detail = document.querySelector('#DropDetail');
  if (!listing || !detail) return;
  const initialParams = new URLSearchParams(window.location.search);
  const oldPreorder = initialParams.get('preorder');
  if (oldPreorder === 'cozy-hoodie-grey' || oldPreorder === 'cozy-straight-leg-sweats-grey') {
    window.location.replace('/products/' + encodeURIComponent(oldPreorder));
    return;
  }
  if (location.search.includes('contact_posted=true') && sessionStorage.getItem('unlisted_preorder')) {
    const saved = sessionStorage.getItem('unlisted_preorder');
    history.replaceState({}, '', `?preorder=${encodeURIComponent(saved)}#DropPreorderForm`);
    sessionStorage.removeItem('unlisted_preorder');
  }
  function show() {
    const params = new URLSearchParams(location.search);
    const key = params.get('preorder');
    const item = key === 'cozy-fold-over-waist-sweatpants-grey' ? products[key] : null;
    listing.hidden = !!item;
    detail.hidden = !item;
    document.querySelector('.drop-film').hidden = !!item;
    if (!item) {
      const category = params.get('collection');
      const soldOut = document.querySelector('#DropSoldOut');
      listing.querySelector('.drop-grid').hidden = category === 't-shirts';
      soldOut.hidden = category !== 't-shirts';
      listing.querySelector('h1').textContent = category === 'hoodies' ? 'HOODIES' : category === 'sweatpants' ? 'SWEATPANTS' : category === 't-shirts' ? 'T-SHIRTS' : 'THE COZY DROP';
      listing.querySelectorAll('[data-category]').forEach(card => { card.hidden = !!category && category !== 't-shirts' && card.dataset.category !== category; });
      return;
    }
    detail.querySelector('[data-drop-title]').textContent = item.title;
    detail.querySelector('[data-drop-price]').textContent = item.price;
    detail.querySelector('#DropProductSelect').value = item.title;
    detail.querySelector('[data-drop-gallery]').innerHTML = item.images.map((file, i) => `<img src="${base}${file}" alt="${item.title} image ${i + 1}" loading="${i ? 'lazy' : 'eager'}" width="1000" height="1000">`).join('');
    document.title = `${item.title} – UNLISTED™`;
  }
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-preorder-link], [data-drop-back]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    history.pushState({}, '', link.href);
    show(); window.scrollTo({top:0,behavior:'instant'});
  });
  window.addEventListener('popstate', show);
  detail.querySelector('form').addEventListener('submit', () => {
    sessionStorage.setItem('unlisted_preorder', new URLSearchParams(location.search).get('preorder') || '');
  });
  show();
})();

// Direct checkout for in-stock products: adds selected variant then opens Shopify checkout.
document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-unlisted-buy-now]');
  if (!button) return;
  const form = button.closest('form');
  const select = form && form.querySelector('select[name="id"]');
  if (!form || !select || !select.value) return;
  button.disabled = true;
  const label = button.textContent;
  button.textContent = 'OPENING CHECKOUT…';
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Accept':'application/json','Content-Type':'application/json'},
      body: JSON.stringify({items:[{id:Number(select.value),quantity:1}]})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Unable to add this size.');
    window.location.assign('/checkout');
  } catch (error) {
    button.disabled = false;
    button.textContent = label;
    alert(error.message || 'Unable to open checkout. Please try Add to Cart.');
  }
});
